<template>
  <div>
    <!-- <ParentBar></ParentBar> -->
    <layout :isSuccess="isSuccess">
      <template v-slot:headZone>
        <headline
          :content="$t('product.product_information')"
          :badge-content="getProductTotal + ' ' + $t('list')"
        >
          <div class="d-block w-100">
            <div class="justify-end mb-2 d-flex">
              <v-btn
                color="info"
                elevation="0"
                @click="createProductDialog = true"
                ><v-icon left>mdi-plus</v-icon>{{ $t('product.add_product') }}</v-btn
              >
            </div>
            <v-text-field
              max-width="300"
              :placeholder="$t('product.search_product')"
              :label="$t('product.search_product')"
              append-icon="mdi-magnify"
              v-model="search"
              color
              background-color="grey lighten-4"
              solo
              flat
              dense
            ></v-text-field>
          </div>

          <form-product
            v-model="createProductDialog"
            event="create"
            @onLoad="getProduct"
          ></form-product>
        </headline>
      </template>
      <template v-slot:containerZone>
        <products :search="search" @onLoad="getProduct"></products>
      </template>
    </layout>
  </div>
</template>

<script>
import FormProduct from "../../components/FormProduct.vue";
import Products from "../../components/Products.vue";
import Headline from "../../components/Headline.vue";
import ParentBar from "../../components/ParentBar";
import { mapGetters } from "vuex";
import Layout from "../../components/Layout.vue";
export default {
  components: {
    FormProduct,
    Products,
    ParentBar,
    Headline,
    Layout,
  },
  name: "Product",
  computed: {
    ...mapGetters({
      getProductTotal: "product/getProductTotal",
    }),
  },
  async created() {
    this.getProduct();
  },
  async mounted() {},
  data() {
    return {
      isSuccess: true,
      createProductDialog: false,
      search: "",
    };
  },
  props: {},
  methods: {
    async getProduct() {
      this.isSuccess = false;
      await this.$store.dispatch("product/getProducts", {
        projectId: this.$route?.params?.projectId,
      });
      this.isSuccess = true;
    },
    getMarket() {
      this.isSuccess = false;
      this.$store
        .dispatch("markets/getMarketArea", { id: this.$route.params.marketId })
        .then((data) => {
          this.getProduct();
          this.isSuccess = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
